import { Card, Spin, Table, Tag } from "antd";
import { Breakpoint } from "antd";
import { useCallback, useContext, useEffect, useState } from "react";
import { useLanguage } from "../../../../context/LanguageContext";
import UserContext from "../../../../context/UserContext";
import { Link } from "react-router-dom";
import { SafetyCertificateOutlined, SecurityScanOutlined, WarningOutlined } from "@ant-design/icons";
import SweepSecurityBase from "../../../../models/Security";
import SecurityService from "../../../../services/SecurityService";
import { getWarehouseReferenceColor } from "../../../../common/warehouseColorReferences";

const SafetyAndSecurity = () => {
    const isMobile = useContext(UserContext).isMobile;
    const { language } = useLanguage();
    const [loading, setLoading] = useState(true);
    const [sweepSecurity, setSweepSecurity] = useState<SweepSecurityBase[]>([]);
    const detailIconStyle = { fontSize: 20, color: "#1677ff", cursor: "pointer" };

    const updateContent = useCallback(() => {
        SecurityService.getSecuredSweeps().then((res) => {
            if (res === null) {
                return
            }
            setSweepSecurity(res);
            setLoading(false);
        })
    }, []);

    useEffect(() => {
        updateContent();
        const interval = setInterval(() => {
            updateContent();
        }, 600000);
        return () => clearInterval(interval);
    }, [updateContent]);

    const getStatusTag = (status: string) => {
        let tagIcon;
        let tagColor;
        let showstatus;
        switch (status) {
            case "not secured":
                tagIcon = <WarningOutlined />;
                tagColor = "yellow";
                showstatus = language === "es" ? "inseguro" : "not secured"
                break;
            case "secured":
                tagIcon = <SafetyCertificateOutlined />;
                tagColor = "green";
                showstatus = language === "es" ? "seguro" : "secured";
                break;
            default:
                tagIcon = null;
                tagColor = "default";
        }
        return isMobile ? <Tag icon={tagIcon} color={tagColor}></Tag> : <Tag icon={tagIcon} color={tagColor}>{showstatus}</Tag>;
    };

    const columns = [
        {
            title: "",
            key: "idx",
            width: 50,
            responsive: ["lg"] as Breakpoint[],
            render: (item: SweepSecurityBase) => item.idx || "",
        },
        {
            title: language === "es" ? "Depósito" : "Warehouse",
            key: "warehouse",
            width: 120,
            render: (item: SweepSecurityBase) => {
                const warehouseName = item.warehouse || "";
                const color = getWarehouseReferenceColor(warehouseName);

                return (
                    <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                        <span
                            style={{
                                width: 10,
                                height: 10,
                                borderRadius: "50%",
                                backgroundColor: color,
                                display: "inline-block",
                            }}
                        />
                        <span style={{ color, fontWeight: 600 }}>{warehouseName || "-"}</span>
                    </span>
                );
            },
        },
        {
            title: language === "es" ? "Número de conteo" : "Counting number",
            key: "counting_number",
            width: 120,
            render: (item: SweepSecurityBase) => item.counting_number || "",
        },
        {
            title: language === "es" ? "Fecha" : "Date",
            key: "timestamp_start",
            width: 120,
            responsive: ["lg"] as Breakpoint[],
            render: (item: SweepSecurityBase) => item.timestamp_start.slice(0, 11) || "",
        },
        {
            title: language === "es" ? "Estado" : "Status",
            key: "status",
            width: 80,
            render: (item: SweepSecurityBase) => getStatusTag(item.status)
        },
        {
            title: language === "es" ? "Seguridad" : "Safety",
            key: "details",
            width: 80,
            align: "center" as const,
            render: (item: SweepSecurityBase) => (
                <Link to={`${item.idx}`}>
                    <SecurityScanOutlined style={detailIconStyle} />
                </Link>
            ),
        },
    ];

    const paginationConfig = {
        // current: props.page,
        // pageSize: props.pageSize,
        // total: props.total,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50"],
        onChange: (page: number, pageSize: number | undefined) => {
            if (pageSize) {
                // props.onPageChange(page, pageSize);
            }
        }
    }

    return (
        <Spin
            spinning={loading}>
            <Card
                title={language === "es" ? "Seguridad" : "Safety and Security"}
                style={{
                    margin: isMobile ? '10px' : '20px',
                    padding: isMobile ? '10px' : '20px',
                }}
            >
                <Table
                    columns={columns}
                    dataSource={sweepSecurity}
                    rowKey="id"
                    scroll={{ x: (isMobile ? 680 : 1100) }}
                    size="small"
                    pagination={paginationConfig}
                />
            </Card>
        </Spin>
    );
};

export default SafetyAndSecurity;